///<reference path="../CustomTypes/ckeditor.temp.index.d.ts" />

import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { LCDocumentEditor } from './LCDocumentEditor';
import { LectioEditorLinkPlugin } from './LectioEditorLinkPlugin';
import { LectioJSUtils } from './../LectioJSUtils';
import { SelectionDialogs } from './../SelectionDialogs';
import { EditorConfig } from './Types';
import { PluginCommentBlock2 } from './PluginCommentBlock2';

export namespace EditorAttachedFilePlugin {
	export function GetFilenameExtension(filename: string): string {
		const arr = filename.match(/\.(\w+)$/);
		return arr ? arr[1].toLowerCase() : '';
	}

	export function CreateOrUpdateAttachedFileFile(
		editor: CKEDITOR.editor,
		serializedId: string,
		filename: string,
		insertMode: boolean
	): void {
		const link = LCDocumentEditorUtils.GetResourceUrl(serializedId, filename);
		let a: CKEDITOR.dom.element;
		if (insertMode)
			a = editor.document.createElement('a');
		else {
			const selection = editor.getSelection()!;
			const element = selection.getStartElement();
			a = element.getAscendant('a', true) as CKEDITOR.dom.element;
		}
		a.setAttribute('href', link);
		a.setAttribute('data-lc-display-linktype', 'file');
		if (insertMode) {
			a.setText(filename);
			editor.insertElement(a);
			editor.insertHtml('&nbsp;');
		}
	}

	export function GetImageSize(src: string): Promise<{ width: number, height: number }> {
		LectioJSUtils.AssertNotNullOrEmpty(src, 'src');

		function getNatural(image: HTMLImageElement) {
			if (image.naturalWidth) {
				return {
					width: image.naturalWidth,
					height: image.naturalHeight
				};
			} else {
				const img = new Image();
				img.src = image.getAttribute('src') || '';

				return {
					width: img.width,
					height: img.height
				};
			}
		}

		const rv = LectioJSUtils.CreateDeferred<{ width: number, height: number }>();
		const image = document.createElement('img');
		image.addEventListener('load', () => {
			const dimensions = getNatural(image);

			rv.resolve(dimensions);
		});

		image.addEventListener('error', () => {
			rv.resolve({
				width: 0,
				height: 0
			});
		});

		image.addEventListener('abort', () => {
			rv.resolve({
				width: 0,
				height: 0
			});
		});

		image.setAttribute('src', src + '?' + Math.random().toString(16).substring(2));

		return rv.promise();
	}




}
